import React from 'react';
import CustomInput from '../../components/CustomInput';

import { BoxInput, TitleInput } from './input.styles';

const Input = ({ title, margin, onChange, ...props }) => {
    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("margin",margin)

    return (
      <BoxInput>
        {title && <TitleInput>{title}</TitleInput>}
        <CustomInput 
            onChange={onChange} 
            style={{
                border: 'none',
                boxShadow: 'none',
                padding: '12px 16px',
                fontSize: '1rem',
                borderRadius: '0'
            }}
            {...props} 
        />
      </BoxInput>
    );
};

export default Input;